/**
 * Every operator screen's nav label, in one place, so `routes.ts`'s
 * `opsNav` entry and whatever else names the screen (a `PageHeader` title
 * where the shell topbar does not already carry it, a breadcrumb caption)
 * cannot read something the nav row does not.
 */

import { defineCatalogue } from '../../i18n';

export const opsTitles = defineCatalogue(
  {
    register: 'Organizações',
    requests: 'Pedidos',
    usage: 'Uso e margem',
    keys: 'Chaves',
    admins: 'Administradores',
    collection: 'Coleta',
    privacy: 'Privacidade',
  },
  {
    register: 'Organisations',
    requests: 'Requests',
    usage: 'Usage and margin',
    keys: 'Keys',
    admins: 'Administrators',
    collection: 'Collection',
    privacy: 'Privacy',
  },
);
